<p>last-updates works!</p>
<div class="news-feed-container">
    <div class="news-feed">
      <div *ngFor="let message of updateMessages">
        <p>
          {{message}}
        </p>
      </div>
    </div>
  </div>